import { Typography } from '@amway/react-components';
import { mdiKeyboardBackspace } from '@mdi/js';
import { useCallback, useEffect, useState } from 'react';
import { Alert, Card, Col, Row } from 'react-bootstrap';
import IconButton from '../../../components/ui/icon-btn';
import useAllowList from '../../../resources/allow-list/allow-list-hook';
import { AllowListRule } from '../../../resources/allow-list/allow-list-model';
import AllowListFormComponent from '../allow-list-form';

type Props = {
  rule: AllowListRule;
  onBackClick: VoidFunction;
};

export default function AllowListEditComponent({ rule, onBackClick }: Props) {
  const { updateRuleStatus, updateRule } = useAllowList();
  const [hasSubmitted, setHasSubmitted] = useState(false);

  useEffect(() => {
    if (updateRuleStatus.success && hasSubmitted) {
      onBackClick();
    }
  }, [onBackClick, updateRuleStatus.success, hasSubmitted]);

  const handleSubmit = useCallback(
    (allowListRule: AllowListRule) => {
      setHasSubmitted(true);
      allowListRule.id = rule.id;
      updateRule(rule.id!, allowListRule);
    },
    [rule.id, updateRule],
  );

  const getErrorMessage = () => {
    if (!hasSubmitted) return null;

    const error = updateRuleStatus.error;
    if (!error) return null;

    if (error.statusCode === 409) {
      return "A rule with this Value, Entry Type, and Rule Type already exists.";
    }

    return error.message;
  };

  const errorMessage = getErrorMessage();

  return (
    <Card className="allow-list-edit">
      <Card.Body>
        <Row>
          <Col>
            <IconButton mdiIconPath={mdiKeyboardBackspace} onClick={onBackClick} title="Back" size="27px">
              Back to Allow List
            </IconButton>
          </Col>
        </Row>
        {errorMessage &&(
          <Row className="mt-3">
            <Col>
              <Alert variant="danger">
                {errorMessage}
              </Alert>
            </Col>
          </Row>
        )}
        <Row>
          <Col>
            <Typography variant="heading">Edit Allow List Rule</Typography>
            <Typography weight="bold" color="text-gray" className="mt-3">
              Edit the fields below.
            </Typography>
          </Col>
        </Row>
        <Row>
          <AllowListFormComponent rule={rule} onSubmit={handleSubmit} submitLabel="UPDATE" />
        </Row>
      </Card.Body>
    </Card>
  );
}
